import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.stickySearch = {
      position: 'sticky',
      top: 0,
      bg: 'background',
      zIndex: 1,
      borderBottom: (t) => `1px solid ${t.colors.gray}`,
    };

    this.inputWrapper = {
      pt: 10,
      pb: '28px',
      px: 8,
      position: 'relative',
      zIndex: 0,
      '.ss-Powered': {
        fontSize: '11px',
        position: 'absolute',
        right: 8,
        bottom: 2,
        color: '#565656',
      },
    };

    this.suggestionsWrapper = {
      p: 8,
      flexDirection: 'column',
      gap: 3,
      borderTop: (t) => `1px solid ${t.colors.gray}`,
      'p, button, span': { variant: 'text.base', lineHeight: 20 },
    };

    this.suggested = {
      fontWeight: 500,
      fontStyle: 'italic',
    };

    this.suggestion = (isLast) => ({
      variant: 'text.base',
      textDecoration: 'underline',
      textDecorationThickness: '1px',
      textUnderlineOffset: '1px',
      fontStyle: 'italic',
      mr: !isLast ? 3 : 0,
      ':after': {
        content: !isLast ? '","' : '""',
      },
    });

    this.empty = {
      p: 12,
      pb: 0,
      position: 'relative',
      variant: 'flex.column',
    };

    this.loadingSpinner = {
      width: '22px',
      height: '22px',
      mx: 'auto',
      color: 'mediumGray',
    };
  })()
);
